
export class GrouperDeleteCommand{
    feeScheduleId: string;
    grouperId:string;
    constructor(feeScheduleId:string, grouperId:string){
        this.feeScheduleId = feeScheduleId;
        this.grouperId = grouperId;
    }
}